export const TRIGGER_REASSON_QUALIFIES = 1
export const TRIGGER_REASSON_IMPROVED_SITE_INFORMATION = 2
export const TRIGGER_REASSON_KBA_CRITERIA_REVISION = 3
export const TRIGGER_REASSON_TAXONOMIC_REVISION = 4
export const TRIGGER_REASSON_REVISION_RED_LIST = 5
export const TRIGGER_REASSON_REVISION_OF_GLOBAL = 6
export const TRIGGER_REASSON_NO_LONGER_GEOGRAPHICALLY = 7
export const TRIGGER_REASSON_GENUINE_DECLINE_IRREVERSIBLE = 8
export const TRIGGER_REASSON_GENUINE_DECLINE_REVERSIBLE = 9
export const TRIGGER_REASSON_GENUINE_DECLINE_OTHER = 10

export const reassessmentTriggerReasons = [
  { id: TRIGGER_REASSON_QUALIFIES, name: 'Qualifies', description: '' },
  { id: TRIGGER_REASSON_IMPROVED_SITE_INFORMATION, name: 'Improved site information', description: '' },
  { id: TRIGGER_REASSON_KBA_CRITERIA_REVISION, name: 'KBA criteria revision', description: '' },
  { id: TRIGGER_REASSON_TAXONOMIC_REVISION, name: 'Taxonomic revision (not present for Ecosystems triggers)', description: '' },
  { id: TRIGGER_REASSON_REVISION_RED_LIST, name: 'Revision to Red List status', description: '' },
  { id: TRIGGER_REASSON_REVISION_OF_GLOBAL, name: 'Revision of global threshold', description: '' },
  { id: TRIGGER_REASSON_NO_LONGER_GEOGRAPHICALLY, name: 'No longer geographically restricted', description: '' },
  { id: TRIGGER_REASSON_GENUINE_DECLINE_IRREVERSIBLE, name: 'Genuine decline, irreversible (can\'t be selected with reversible decline)', description: '' },
  { id: TRIGGER_REASSON_GENUINE_DECLINE_REVERSIBLE, name: 'Genuine decline, reversible (can\'t be selected with irreversible decline)', description: '' },
  { id: TRIGGER_REASSON_GENUINE_DECLINE_OTHER, name: 'Genuine decline, other factors', description: '' }
]
